import type { UUID } from '@cobliteam/common-types';
import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import { tokenValidationV2Transformer } from './APITransformer';
import type { TokenValidationV2 } from './Types';

export class IdentificationTokenRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public saveTokenAssociationV2 = (driverId: UUID, alias: string): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `/driver-identification/v2/drivers/${driverId}`,
      method: HttpMethod.PUT,
      body: JSON.stringify({ token_alias: alias }),
    };
    return this.requester.request(requestData).then();
  };

  public tokenValidationV2 = (tokenAlias: string): Promise<TokenValidationV2> => {
    const requestData: IRequest = {
      endpoint: `/driver-identification/v2/tokens/alias/${encodeURIComponent(tokenAlias)}`,
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData).then((response) => tokenValidationV2Transformer(response.data));
  };
}

export default IdentificationTokenRequester;
